import styled from 'styled-components';
import { Div, Header } from 'components';

export const Wrapper = styled(Div)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({theme}) => theme.colors[theme.background.quaternary.color][[theme.background.quaternary.intensity]]};
`;

export const StyledHeader = styled(Header)`
  border-bottom: none;
`;

export const Content = styled(Div)`
`;